import React, { useState,useEffect } from "react";
import Header from "../../components/Header";
import Watermark from '../../assets/Watermark.png';
import InvitedUsers from "../../components/UserManagment/InvitedUsers";
import RegisteredUsers from "../../components/UserManagment/RegisteredUsers";
import { getCookie } from "../../utils/cookieUtil";

export default function UserManagement() {

  const [activeTab, setActiveTab] = useState("registered");
  const [counter, setCounter] = useState(0);
  const [permission, setPermission] = useState('');

      useEffect(() => {
          const roles = getCookie('roleId');
          if (roles) {
              setPermission(`${roles} `);
          }
      }, []);



  return (
    <div
      className="p-4 space-y-4"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundImage: `url(${Watermark})`,
        backgroundSize: '45%',
        backgroundPosition: 'center 20px',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <Header />

      {/* Tabs */}
      <div className="flex mb-6 overflow-hidden rounded-t-lg ">
        <button
          className={`flex-1 px-6 py-3 text-sm font-semibold transition-all duration-200 focus:outline-none ${activeTab === "registered"
            ? "bg-[#900028] text-white"
            : "bg-[#F2C7C9] bg-opacity-60 text-black-900 border-black"
            }`}
          onClick={() => {
            setActiveTab("registered")
            setCounter(prev => prev + 1);
          }}
        >
          Registered Users
        </button>
        {permission.includes("adduser") && (
        <button
          className={`flex-1 px-6 py-3 text-sm font-semibold transition-all duration-200 focus:outline-none ${activeTab === "invited"
            ? "bg-[#900028] text-white"
            : "bg-[#F2C7C9] bg-opacity-60 text-black-900 border-black"
            }`}
          onClick={() => {
            setActiveTab("invited");
            setCounter(prev => prev + 1);
          }}
        >
          Invited Users
        </button>
        )}
      </div>


      {activeTab === "registered" ? (
        <RegisteredUsers
          counter={counter}
        />
      ) : (
        <InvitedUsers
          counter={counter}
        />
      )}


    </div>
  );
}
